import format from 'string-format';
import { RESX_LISTINGS, RESX_GLOBAL } from '../../Constants';
import GeneralUtility from '../../utilities/generalUtility';
import resx from '../../utilities/resx';

const validationStrings = {
    FirstName: {
        maxLength: format(resx(RESX_GLOBAL, 'MAX_CHARACTERS'), 49),
        valueMissing: resx(RESX_LISTINGS, 'PLZ_ENTER_FIRST_NAME')
    },
    LastName: {
        maxLength: format(resx(RESX_GLOBAL, 'MAX_CHARACTERS'), 29),
        valueMissing: resx(RESX_LISTINGS, 'PLZ_ENTER_LAST_NAME')
    },
    Email: {
        patternMismatch: resx(RESX_LISTINGS, 'PLZ_ENTER_VALID_EMAIL'),
        valueMissing: resx(RESX_LISTINGS, 'PLZ_ENTER_EMAIL')
    },
    Password: {
        valueMissing: resx(RESX_GLOBAL, 'REGISTER_VALIDATION_PW_MIN_SIX_CHAR'),
        minLength: resx(RESX_GLOBAL, 'REGISTER_VALIDATION_PW_MIN_SIX_CHAR'),
        maxLength: format(resx(RESX_GLOBAL, 'MAX_CHARACTERS'), 50)
    }
};

const Validation = (fields, values) => {
    return GeneralUtility.validateFields(fields, validationStrings);
};

export default Validation;
